import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    ButtonItem,
    ErrorItem,
} from "../../../../Components/Items";
import CamposPerimetroChecada, { valoresAPayload, datosAValores } from "../CamposPerimetroChecada";

class EditarPerimetroChecada extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarEditarPerimetroChecada(codigo) {
        this.props.cerrarEditarPerimetroChecada(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "perimetrosChecada/datosPerimetroChecada",
                { empresaId: this.props.empresaId, perimetroChecadaId: this.props.perimetroChecadaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue(datosAValores(res.data.data));
                } else {
                    message.error("Error no se encontro informacion del perímetro");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "perimetrosChecada/editarPerimetroChecada",
                {
                    ...valoresAPayload(values),
                    empresaId: this.props.empresaId,
                    perimetroChecadaId: this.props.perimetroChecadaId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha editado un perímetro de checada");
                    this.formRef.current.resetFields();
                    this.cerrarEditarPerimetroChecada();
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede editar el perímetro");
                } else {
                    message.error("Hubo un error y el perímetro no se editó");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Editar Perímetro de Checada"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarPerimetroChecada.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="editarPerimetroChecada"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <CamposPerimetroChecada
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                        />
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(EditarPerimetroChecada);
